/**
 * Audit C3: the gates the World approves only on the card that shows the stored change (backend
 * lib/gateCatalog.js CARD_APPROVED_GATE_KEYS: a price change, Can 68; a change to who belongs to a World, Can 73; a coding job, Can 81).
 * Such a step is accepted only on its card in Cleo on the Desk; Pocket, the phone and any door may decline it, never
 * accept it.
 *
 * The World marks such a gate on the approval it opens (gate.cardApproved, lib/worldAuth.js projectGateInstance), so
 * a card gate the catalog adds later reaches every app with no change here. An approval without the mark (an older
 * World, a lane that did not carry it) is read by its gate key, from this mirror of the catalog's keys, which
 * cardApprovedGates.test.ts holds equal to the World's list.
 */
export const CARD_APPROVED_GATE_KEYS: ReadonlyArray<string> = Object.freeze([
  "HG-COMMERCE-PRICE-01",
  "HG-WORLD-GOVERN-02",
  "HG-CODE-JOB-01",
]);

/** Whether an approval's gate is approved only on its card: the World's mark, or a card-approved gate key. */
export function isCardApprovedGate(gate: unknown): boolean {
  if (typeof gate !== "object" || gate === null) return false;
  const g = gate as { readonly cardApproved?: unknown; readonly gateKey?: unknown };
  if (g.cardApproved === true) return true;
  return typeof g.gateKey === "string" && CARD_APPROVED_GATE_KEYS.includes(g.gateKey);
}
